import React from 'react';
import EcoAssociation9Class2025 from 'views/EcoAssociation9Class2025';

const AccountGeneralPage = () => {
  return <EcoAssociation9Class2025/>;
};

export default AccountGeneralPage;